import { render, staticRenderFns } from "./MainViewMode.vue?vue&type=template&id=3e0a0024&scoped=true"
import script from "./MainViewMode.vue?vue&type=script&lang=ts"
export * from "./MainViewMode.vue?vue&type=script&lang=ts"
import style0 from "./MainViewMode.vue?vue&type=style&index=0&id=3e0a0024&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0a0024",
  null
  
)

export default component.exports